import styled from 'styled-components';
import { Col, Row, Button } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { CircularProgressbar } from 'react-circular-progressbar';
import { MdError, MdVideocam, MdCheckCircle, MdDeleteForever } from 'react-icons/md';

const CONTENT_OFFSET = '3rem';
const FILE_NAME_OFFSET = '1rem';
const REPORTS_BAR_HEIGHT = '2.5rem';
const DELETE_CONFIRM_ICON_COLOR = '#D13342';
const ERROR_ICON_COLOR = '#E57878';
const SUCCESS_ICON_COLOR = '#78E5D5';
const UPLOAD_ACCENT_COLOR = '#7159C1';
const UPLOAD_PROGRESS_SIZE = '1.5rem';

export const Container = styled.div`
	padding-top: 0.9375rem;
	padding-bottom: 1.25rem;
`;

export const ReportsBar = styled.div`
	width: 100%;
	height: ${REPORTS_BAR_HEIGHT};
`;

export const ReportsButton = styled(Button)`
	display: block;
	float: right;
`;

export const ItemRow = styled(Row)`
	width: 100%;
`;

export const HeaderCol = styled(Col)`
	padding-left: ${CONTENT_OFFSET};
`;

export const DescriptionCol = styled(Col)`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	padding-left: ${CONTENT_OFFSET};
`;

export const LeftAlignedCol = styled(Col)`
	text-align: left;
`;

export const CenteredCol = styled(Col)`
	text-align: center;
`;

export const FileName = styled.strong`
	padding-left: ${FILE_NAME_OFFSET};
`;

export const DeleteConfirmIcon = styled(QuestionCircleOutlined)`
	color: ${DELETE_CONFIRM_ICON_COLOR};
`;

export const VideoIcon = styled(MdVideocam)`
	color: ${UPLOAD_ACCENT_COLOR};
`;

export const ErrorIcon = styled(MdError)`
	color: ${ERROR_ICON_COLOR};
`;

export const DeleteIcon = styled(MdDeleteForever)`
	color: ${ERROR_ICON_COLOR};
`;

export const SuccessIcon = styled(MdCheckCircle)`
	color: ${SUCCESS_ICON_COLOR};
`;

export const UploadProgress = styled(CircularProgressbar)`
	&& {
		width: ${UPLOAD_PROGRESS_SIZE};

		.CircularProgressbar-path {
			stroke: ${UPLOAD_ACCENT_COLOR};
		}
	}
`;
